import { CSSProperties, FC, ReactElement } from 'react'
import { Container } from './styles'

type FrameProps = {
  children: ReactElement | string | (string | ReactElement)[]
  style?: CSSProperties
}

const Frame: FC<FrameProps> = ({ style, children }): ReactElement => {
  return (
    <Container className='frame' style={style}>
      {children}
    </Container>
  )
}

export default Frame
